import NewsCard from "../../Components/NewsCard/NewsCard";
import { useConfigStore } from "../../Stores/Config";
import { useNewsStore } from "../../Stores/News";
import { ReactComponent as AnnouncementsActive } from "../../Assets/megaphone-solid.svg";
import "./News.scss";

function News() {
  const newsStore = useNewsStore();
  const articles = useNewsStore((state) => state.articles);
  const configStore = useConfigStore();

  return (
    <div className="news">
      {newsStore.articles.length === 0 && !newsStore.loadingNews && (
        <div className="no-news">
          <AnnouncementsActive className="no-news-yet" />
          <span className="title">{configStore.config.newsMenuLabel}</span>
          <span className="description">
            {configStore.translateText("noNews")}
          </span>
        </div>
      )}
      {articles.map((news) => {
        return <NewsCard news={news} key={news.id} />;
      })}
      {newsStore.articles.length !== 0 && newsStore.hasMore && (
        <div className="load-more-container">
          <div
            className={`load-more`}
            onClick={() => {
              newsStore.loadNews();
            }}
          >
            <span>{configStore.translateText("loadMore")}</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default News;
